module.exports = {"description":"云商城后台系统","username":"请输入用户名","password":"请输入密码","login":"登录"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/zh-CN.json
// module id = GsS1
// module chunks = 72